// extracted by css-extract-rspack-plugin
export default {"nav":"ResultListHeader-module__nav__l5vhGqt"};